/**
 * Query key factory for Moodboard
 * 
 * This file provides a consistent way to define query keys for React Query
 * to properly deduplicate and invalidate related queries.
 */

/**
 * Centralized query keys for moodboard items to ensure consistent cache management
 */
export const moodboardKeys = {
  // Base key for all moodboard-related queries
  all: ['moodboardItems'] as const,
  
  // Key for lists of moodboard items
  lists: () => [...moodboardKeys.all, 'list'] as const,
  
  // Key for filtered lists with parameters
  list: (filters: Record<string, any>) => [...moodboardKeys.lists(), filters] as const,
  
  // Key for moodboard items by topic ID
  byTopic: (topicId: string) => [...moodboardKeys.lists(), { topicId }] as const,
  
  // Key for moodboard items filtered by user ID
  byUser: (userId: string) => [...moodboardKeys.lists(), { userId }] as const,
  
  // Base key for moodboard item detail queries
  details: () => [...moodboardKeys.all, 'detail'] as const,
  
  // Key for a specific moodboard item by ID
  detail: (id: string) => [...moodboardKeys.details(), id] as const,
};